import { render, staticRenderFns } from "./LayerPanel.vue?vue&type=template&id=0a131f2a&scoped=true"
import script from "./LayerPanel.vue?vue&type=script&lang=js"
export * from "./LayerPanel.vue?vue&type=script&lang=js"
import style0 from "./LayerPanel.vue?vue&type=style&index=0&id=0a131f2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a131f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a131f2a')) {
      api.createRecord('0a131f2a', component.options)
    } else {
      api.reload('0a131f2a', component.options)
    }
    module.hot.accept("./LayerPanel.vue?vue&type=template&id=0a131f2a&scoped=true", function () {
      api.rerender('0a131f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/LayerPanel.vue"
export default component.exports